import React, { useState, useEffect, useMemo } from 'react'
import axios from 'axios'
import { Helmet } from 'react-helmet'
import { useHistory, useLocation } from 'react-router-dom'
import queryString from 'query-string'
import mixpanel from '../../utilities/mixpanel'

import { extractErrorMessage } from '../../utilities/errorHelpers'
import NewPasswordModal from '../leevo_ui/NewPasswordModal/NewPasswordModal'

function newPasswordUrlIsMissingQueryStringParams(parsedParams) {
  const requiredParamsByDevise = ['access-token', 'client', 'expiry', 'uid']

  return requiredParamsByDevise.some((requiredParam) => !parsedParams[requiredParam])
}

export default function NewPasswordFeature() {
  const [successMessage, setSuccessMessage] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const history = useHistory()
  const location = useLocation()

  const parsedQueryStringParams = useMemo(() => {
    const params = queryString.parse(location.search)
    params['token-type'] = 'Bearer'
    return params
  }, [location.search])

  useEffect(() => {
    if (newPasswordUrlIsMissingQueryStringParams(parsedQueryStringParams)) {
      setErrorMessage('Invalid or expired password reset link. Please request a new password reset.')
      const timeoutId = setTimeout(() => {
        history.push('/')
      }, 3000)
      return () => clearTimeout(timeoutId)
    }
  }, [parsedQueryStringParams, history])

  function newPasswordSubmission({ password, passwordConfirmation }) {
    setSuccessMessage('')
    setErrorMessage('')
    const headers = {
      'access-token': parsedQueryStringParams['access-token'],
      client: parsedQueryStringParams.client,
      expiry: parsedQueryStringParams.expiry,
      'token-type': 'Bearer',
      uid: parsedQueryStringParams.uid
    }

    return axios
      .create({ headers })
      .put('/auth/password', {
        password,
        password_confirmation: passwordConfirmation
      })
      .then(({ data }) => {
        mixpanel.track('Password Reset Successful')
        setSuccessMessage(data.message)
        history.push({
          pathname: '/login',
          state: {
            message: 'You have successfully created a new password!'
          }
        })
      })
      .catch((error) => {
        mixpanel.track('Password Reset Failed')
        setErrorMessage(extractErrorMessage(error))
      })
  }

  return (
    <>
      <Helmet>
        <title>New Password | Leevo</title>
      </Helmet>
      <NewPasswordModal
        errorMessage={errorMessage}
        newPasswordSubmission={newPasswordSubmission}
        successMessage={successMessage}
      />
    </>
  )
}
